const PrivacyPolicy = {
  'pages_terms_PrivacyPolicy.1': '개인정보 처리방침',
}

export default PrivacyPolicy


// WEBPACK FOOTER //
// ./src/lang/terms/PrivacyPolicy.kr.js